import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import App from './App.tsx'
import './index.css'
import LoginPage from './pages/LoginPage.tsx'
import GenerationPage from './pages/GenerationPage.tsx'
import ResultPage from './pages/ResultPage.tsx'
import EditorPage from './pages/EditorPage.tsx'
import { AuthGuard } from './components/auth-guard.tsx'
import { Toaster } from './components/ui/toaster.tsx'
import { ThemeProvider } from './components/theme-provider.tsx'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Router>
      <ThemeProvider defaultTheme="dark" storageKey="vite-ui-theme">
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route
            path="/"
            element={
              <AuthGuard>
                <GenerationPage />
              </AuthGuard>
            }
          />
          <Route
            path="/result/:artId"
            element={
              <AuthGuard>
                <ResultPage />
              </AuthGuard>
            }
          />
          <Route
            path="/editor/:artId"
            element={
              <AuthGuard>
                <EditorPage />
              </AuthGuard>
            }
          />
        </Routes>
        <Toaster />
      </ThemeProvider>
    </Router>
  </React.StrictMode>,
)


